import { createCouponCodeEvent } from '@/scopes/checkout/domain/analytics/index'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import * as React from 'react'

export function useSendCouponCodeEvent(result: string | undefined) {
  const { sendEvent } = useAnalytics()
  const hasBeenSent = React.useRef(false)

  const sendCouponCodeEvent = React.useCallback(() => {
    if (!result)
      return
    sendEvent(
      createCouponCodeEvent({
        result,
      }),
    )
  }, [sendEvent, result])

  React.useEffect(() => {
    if (hasBeenSent.current)
      return
    if (!result)
      return
    sendCouponCodeEvent()
    hasBeenSent.current = true
  }, [sendCouponCodeEvent, hasBeenSent, result])

  return {
    sendCouponCodeEvent,
  }
}
